import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password })
      });
      
      if (response.ok) {
        const data = await response.json();
        // Store token in localStorage as fallback for browsers that block cookies
        if (data.token) {
          localStorage.setItem('session_token', data.token);
        }
        if (data.user_id) {
          localStorage.setItem('user', JSON.stringify({
            user_id: data.user_id,
            email: data.email,
            name: data.name,
            role: data.role,
            picture: data.picture
          }));
        }
        window.location.href = '/cms';
      } else {
        const errorData = await response.json().catch(() => ({}));
        setError(errorData.detail || 'Invalid email or password');
        setLoading(false);
      }
    } catch (err) {
      setError('Connection error - please try again');
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      backgroundColor: '#000',
      color: '#fff',
      fontFamily: 'sans-serif'
    }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '20px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '30px', letterSpacing: '2px' }}>
          CULTURAL REVOLUTION
        </h1>
        <p style={{ textAlign: 'center', marginBottom: '30px', opacity: 0.7, fontSize: '12px' }}>
          CMS LOGIN
        </p>
        
        {error && (
          <div style={{ 
            padding: '10px', 
            marginBottom: '20px', 
            border: '1px solid #ff4444',
            color: '#ff4444',
            textAlign: 'center',
            fontSize: '12px'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', opacity: 0.7 }}>
              EMAIL
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#111',
                border: '1px solid #333',
                color: '#fff',
                fontSize: '14px',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', opacity: 0.7 }}>
              PASSWORD
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#111',
                border: '1px solid #333',
                color: '#fff',
                fontSize: '14px',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#fff',
              color: '#000',
              border: 'none',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? 'SIGNING IN...' : 'SIGN IN'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
